import getModuleSwitcherItemUrl from './getModuleSwitcherItemUrl';
import { IOverflowSetItemProps } from '@fluentui/react/lib/OverflowSet';
import { Module } from 'owa-bootstrap';
import { IIconProps } from '@fluentui/react/lib/Icon';
import { onModuleClick } from 'owa-left-rail-utils';
import { isModuleSwitchEnabled } from './isModuleSwitchEnabled';
import getSelectedOfficeRailApp from './selectors/getSelectedOfficeRailApp';

export default function getModuleSwitcherItem(
    moduleType: Module,
    selectedModule: Module,
    displayName: string,
    iconProps: IIconProps,
    activeModuleAction?: (ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>) => void
): IOverflowSetItemProps {
    const isSelected = moduleType === selectedModule && !getSelectedOfficeRailApp();
    let href = '';
    /* If module is selected, don't want to reboot whole page */
    if (!isModuleSwitchEnabled(selectedModule, moduleType) && selectedModule != moduleType) {
        href = getModuleSwitcherItemUrl(moduleType);
    }
    return {
        key: displayName,
        iconProps: iconProps,
        text: displayName,
        title: displayName,
        ariaLabel: displayName,
        name: displayName,
        workload: moduleType,
        isSelected: isSelected,
        href: href,
        onClick: () => {
            onModuleClick(moduleType, selectedModule, activeModuleAction);
        },
    };
}
